<template>
  <div class="posters">
    <div style="background-color:white; padding:0.63rem; padding-bottom:0.3rem;">
      <div id="video_img" class="video_img">
        <img v-if="data.file_type == 2" class="video_play_img" src="@/assets/images/doctor/posters_play.png">
      </div>
    </div>
    <p class="posters_title">{{data.title}}</p>
    <div class="posters_doctor_info">
      <img class="posters_icon" :src="data.doctor_photo">
      <div class="posters_info_wrap">
        <p class="posters_name">{{data.doctor_name}}</p>
        <p class="posters_rank">{{data.doctor_position+'&nbsp;/'+'&nbsp;'+data.department_name}}</p>
        <p class="posters_hospital">{{data.hospital_name}}</p>
      </div>
    </div>
    <div class="qrcode_wrap">
      <div class="tips_wrap">
        <span class="tips tips_first">扫码识别二维码</span>
        <span class="tips tips_second">查看 TA 的作品</span>
      </div>
      <div style="flex:1;"></div>
      <img class="qrcode" :src="data.production_poster_qrcode" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    components: {

    },
    props: {
      isVideo: {
        type: Boolean,
        required: false,
        default: true
      },
      data: {
        type: Object,
        required: true,
        default: {}
      }
    },
    mounted() {
      if (this.data.file_type == 2 || this.data.file_type == 9) {
        let node = document.querySelector('#video_img')
        node.style.backgroundImage = 'url(' + this.data.file_cover + ')'
        node.style.backgroundPosition = 'center center'
        node.style.backgroundSize = 'cover'
        node.style.backgroundRepeat = 'no-repeat'
      } else {
        this.file_icon = this.checkFileType(this.data.file_type)
      }
    },
    methods: {
    },
    data() {
      return {
        file_icon: ''
      }
    }
  }
</script>
<style scoped>
  .video_img {
    display: flex;
    height: 8rem;
    width: 100%;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    justify-content: center;
    align-items: center;
  }

  .video_play_img {
    width: 2.11rem;
    height: 2.11rem;
  }

  .file_img {
    width: 1.54rem;
    height: 1.75rem;
  }

  .posters_title {
    margin: 0;
    overflow: hidden;
    line-height: 0.68rem;
    font-size: 0.68rem;
    height: 1.3rem;
    background-color: white;
    padding-left: 0.63rem;
    padding-right: 0.63rem;
    color: #444444;
  }

  .posters_doctor_info {
    height: 4rem;
    display: flex;
    flex-direction: row;
    padding: 0.84rem;
    padding-top: 0.3rem;
    background-color: white;
  }

  .posters_info_wrap {
    display: flex;
    flex-direction: column;
    margin-left: 0.7rem;
  }

  .posters_icon {
    width: 3.16rem;
    height: 3.16rem;
    border-radius: 1.58rem;
  }

  .posters_name {
    margin: 0;
    font-size: 0.84rem;
    color: #444444;
  }

  .posters_rank {
    margin-top: 0.44rem;
    font-size: 0.51rem;
    color: #444444;
  }

  .posters_hospital {
    margin: 0;
    font-size: 0.51rem;
    color: #444444;
  }

  /* @media all and (-ms-high-contrast: none),
  (-ms-high-contrast: active) {
    .posters_doctor_info {
      padding-top: 0;
    }

    .posters_icon {
      margin-top: 0.3rem;
    }

    .posters_name {
      height: 0.2rem;
    }

    .posters_rank {
      height: 0.2rem;
    }
  } */

  .posters_desc {
    width: 12.2rem;
    height: 5.9rem;
    padding: 0.63rem;
    background-color: white;
    position: relative;
  }

  .posters_desc_content {
    font-size: 0.51rem;
    color: #888888;
    line-height: 0.84rem;
    overflow: hidden;
    height: 6.5rem;
  }

  .line {
    height: 1px;
    width: 100%;
  }

  .qrcode_wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 5.45rem;
    background-color: white;
    border-top: 1px solid #ececec;
  }

  .tips_wrap {
    display: flex;
    flex-direction: column;
    padding-left: 1.89rem;
  }

  .tips {
    font-size: 0.59rem;
    color: #444444;
  }

  .tips_second {
    margin-top: 0.5rem;
  }

  .qrcode {
    width: 3.79rem;
    width: 3.79rem;
    margin-right: 1.47rem;
  }

  .desc_mask {
    position: absolute;
    width: 12.2rem;
    height: 1.5rem;
    bottom: 0;
  }
</style>